<!-- GLOBAL LOADER -->
<div *ngIf="isLoading" class="fixed inset-0 flex items-center justify-center z-[9999] backdrop-blur-sm bg-white/90">
  <i class="fas fa-spinner fa-spin text-6xl" style="color:#c19725;"></i>
</div>

<ng-container *ngIf="isUnauthPage && loginTypeLoaded">
  <ng-container *ngIf="mainlogin">
    <app-unauthenticated-layout />
  </ng-container>
  <ng-container *ngIf="simplelogin">
    <app-simple-unauth />
  </ng-container>
</ng-container>

<ng-container *ngIf="isSignupPage">
  <app-signup />
</ng-container>

<ng-container *ngIf="isHomePage && isLoggedIn">
  <app-home />
</ng-container>


<ng-container *ngIf="isAuthPage">
  <app-authenticated-layout />
</ng-container>

<ng-container *ngIf="isGstInvoicePage || (isAccountsPage && isRegistered)">
  <app-gst-layout />
</ng-container>